import { StackdriverErrorReporter } from 'stackdriver-errors-js'

const environment = process.env.NODE_ENV
let errorHandler

if (environment === 'production') {
  window.StackTrace = require('stacktrace-js')
  errorHandler = new StackdriverErrorReporter()
  errorHandler.start({
    key: process.env.REACT_APP_FIREBASE_APIKEY,
    projectId: process.env.REACT_APP_FIREBASE_PROJECTID
    // service: '<my-service>', // (optional)
    // version: '<my-service-version>' // (optional)
    // reportUncaughtExceptions: false          // (optional) Set to false to stop reporting unhandled exceptions.
    // reportUnhandledPromiseRejections: false  // (optional) Set to false to stop reporting unhandled promise rejections.
    // disabled: true                           // (optional) Set to true to not report errors when calling report(), this can be used when developping locally.
    // context: {user: 'user1'}                 // (optional) You can set the user later using setUser()
  })
} else {
  errorHandler = { report: console.error, setUser: console.log }
}

export default errorHandler
